module.exports = __webpack_public_path__ + "static/media/campus-platform-moduleB-icon11.eef79d1d.png";